import { TMenuItemType } from '../../types/menu.types';
import { IFormOptionGroup, IFormPriceBand } from '../../types/menuItemForm.types';

export interface ICreateGlobalItemWizardProps {
  open: boolean;
  closeModal: () => void;
  menuId?: string;
  sectionId?: string;
}

export interface IGlobalItem {
  type: TMenuItemType;
  recipe_id: string | null;
  name: string;
  consumer_name: string;
  description: string;
  plu?: string | null;
  image: File | string | null;
  tax_rate: string;
  price_bands?: IFormPriceBand[];
  modifier_groups: IFormOptionGroup[];
  price_scheme_ids: string[];
  ranges?: string[];
  is_hfss: boolean;
  age_verification: boolean;
  source: 'library' | 'ranges';
  deposit_return_scheme: string | null;
  party_size: number | null;
  is_enhanced_bundle: boolean;
}

export enum Steps {
  type = 0,
  details = 1,
  tax = 2,
  bundleCategory = 3,
  bundlePriceSchemes = 4,
  bundlePricing = 5,
}
